module.exports = __webpack_public_path__ + "static/media/HomeWayDqPro_v2.920d373a.jpg";